import React from 'react';

import ConfigForm from './ConfigForm';
import UsersMappingsTable from './UsersMappingsTable';

const ConfigWithAccountsMapping = () => {
  return (
    <div data-cy="top-level-users-mapping" style={{ paddingTop: '20px', width: '100%' }}>
      <ConfigForm/>
      <UsersMappingsTable/>
    </div>
  );
};

export default ConfigWithAccountsMapping;
